export default __webpack_public_path__ + "static/media/sounds/clic_continuare_2021_Alyx.mp3";